import { render, staticRenderFns } from "./my_timeoff.vue?vue&type=template&id=97961334&scoped=true&"
import script from "./my_timeoff.vue?vue&type=script&lang=js&"
export * from "./my_timeoff.vue?vue&type=script&lang=js&"
import style0 from "./my_timeoff.vue?vue&type=style&index=0&id=97961334&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97961334",
  null
  
)

export default component.exports